import { render, staticRenderFns } from "./flowPool.vue?vue&type=template&id=22fa53ea&scoped=true&"
import script from "./flowPool.vue?vue&type=script&lang=js&"
export * from "./flowPool.vue?vue&type=script&lang=js&"
import style0 from "./flowPool.vue?vue&type=style&index=0&id=22fa53ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa53ea",
  null
  
)

export default component.exports